

import { NgModule } from '@angular/core';
import { AngularSplitModule } from 'angular-split';
import { TnxSharedModule } from 'tnx-shared';
import { RoleFormComponent } from './role-form/role-form.component';
import { RoleComponent } from './role.component';
import { RoleRoutes } from './role.routing';

export function declaration() {
    return [RoleComponent, RoleFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class RoleModule {
}

@NgModule({
    imports: [RoleModule, RoleRoutes],
    exports: [RoleModule]
})
export class RoleWithRouteModule {
}
